export default __webpack_public_path__ + "static/media/Group 8223.358d39ac.svg";